import React from 'react';
import { ISelectOption } from '../../../domain/saved-filters/interface';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';

interface IAlertTrackStatusSelectProps {
    value: string[] | undefined;
    onChange: (value: string[]) => void;
    options: ISelectOption<string>[];
    label?: string;
    disabled?: boolean;
    isLoading?: boolean;
}

export const AlertTrackStatusSelect: React.FC<IAlertTrackStatusSelectProps> = ({
    disabled = false,
    value = [],
    onChange,
    label,
    options,
    isLoading,
}) => {
    return (
        <BaseFilterCheckboxSelect
            resizable
            searchable
            multiple
            showSelectAllOption={false}
            selectedCountInLabel
            showClear
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            disabled={disabled}
            loading={isLoading}
            height={180}
        />
    );
};
